import { render, staticRenderFns } from "./LogsTable.vue?vue&type=template&id=5a5c31dc&"
import script from "./LogsTable.vue?vue&type=script&lang=js&"
export * from "./LogsTable.vue?vue&type=script&lang=js&"
import style0 from "./LogsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports